import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../../lib/react-query";
import { getSurveyParticipants } from "../api/surveyAPI";
import { RootState } from "../../../../redux/store";
import { useQuery } from "@tanstack/react-query";

type QueryFnType = typeof getSurveyParticipants;

type UseSearchSurveyParticipantsOptions = {
    config?: QueryConfig<QueryFnType>;
    surveyId: number;
};

export const useSurveyParticipants = ({ config, surveyId }: UseSearchSurveyParticipantsOptions) => {
  const surveyParticipantHistorical = useSelector((state: RootState) => state.historical.surveyParticipants);

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: ['surveyParticipants', surveyId, surveyParticipantHistorical.currentPage, surveyParticipantHistorical.itemsPerPage],
    queryFn: () => getSurveyParticipants(surveyId, { pageNumber: surveyParticipantHistorical.currentPage, pageSize: surveyParticipantHistorical.itemsPerPage }),
  });
}